export default __webpack_public_path__ + "static/media/graph.d5234816.jpg";